/* ============================================
   MISSLES Theme v2 — JavaScript
   ============================================ */

// ===== STARS =====
function initStars() {
  const canvas = document.getElementById('star-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
  resize();
  window.addEventListener('resize', resize);

  const stars = Array.from({ length: 180 }, () => ({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    r: Math.random() * 1.2,
    a: Math.random(),
    da: (Math.random() * 0.012 + 0.003) * (Math.random() > .5 ? 1 : -1)
  }));
  const sparkles = Array.from({ length: 10 }, () => ({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    sz: Math.random() * 3.5 + 1.5,
    a: Math.random() * .7,
    da: (Math.random() * .008 + .003) * (Math.random() > .5 ? 1 : -1)
  }));

  function drawSparkle(x, y, sz, a) {
    ctx.save(); ctx.translate(x, y);
    ctx.fillStyle = `rgba(255,255,255,${a})`;
    for (let i = 0; i < 4; i++) {
      ctx.rotate(Math.PI / 2);
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(sz * .22, sz * .22);
      ctx.lineTo(0, sz);
      ctx.lineTo(-sz * .22, sz * .22);
      ctx.closePath(); ctx.fill();
    }
    ctx.restore();
  }

  (function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    stars.forEach(s => {
      s.a = Math.max(0.05, Math.min(1, s.a + s.da));
      if (s.a >= 1 || s.a <= 0.05) s.da *= -1;
      ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255,255,255,${s.a})`; ctx.fill();
    });
    sparkles.forEach(s => {
      s.a = Math.max(0.05, Math.min(.7, s.a + s.da));
      if (s.a >= .7 || s.a <= .05) s.da *= -1;
      drawSparkle(s.x, s.y, s.sz, s.a);
    });
    requestAnimationFrame(loop);
  })();
}

// ===== CURSOR =====
function initCursor() {
  const dot = document.querySelector('.cursor');
  const ring = document.querySelector('.cursor-ring');
  if (!dot || !ring) return;
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    dot.style.left = mx + 'px'; dot.style.top = my + 'px';
  });
  (function animRing() {
    rx += (mx - rx) * .11; ry += (my - ry) * .11;
    ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
    requestAnimationFrame(animRing);
  })();
  const hoverEls = 'a, button, .product-card, .lb-photo, .coll-card, .hero-upload-zone, .coll-img-wrap, .editorial-img-wrap';
  document.querySelectorAll(hoverEls).forEach(el => {
    el.addEventListener('mouseenter', () => dot.classList.add('hover'));
    el.addEventListener('mouseleave', () => dot.classList.remove('hover'));
  });
}

// ===== NAV =====
function initNav() {
  const nav = document.querySelector('.nav');
  if (!nav) return;
  window.addEventListener('scroll', () => nav.classList.toggle('scrolled', window.scrollY > 50), { passive: true });

  const tog = document.getElementById('navToggle') || document.querySelector('.nav-toggle');
  const links = document.getElementById('navLinks') || document.querySelector('.nav-links');

  function closeMenu() {
    links.classList.remove('open');
    tog.querySelectorAll('span').forEach(s => s.style.cssText = '');
  }

  if (tog && links) {
    tog.addEventListener('click', () => {
      links.classList.toggle('open');
      const spans = tog.querySelectorAll('span');
      const open = links.classList.contains('open');
      spans[0].style.cssText = open ? 'transform:rotate(45deg) translate(5px,5px)' : '';
      spans[1].style.cssText = open ? 'opacity:0' : '';
      spans[2].style.cssText = open ? 'transform:rotate(-45deg) translate(5px,-5px)' : '';
    });

    // Fade and close menu when user scrolls down on mobile
    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      if (!links.classList.contains('open')) { lastScrollY = window.scrollY; return; }
      if (window.scrollY - lastScrollY > 8) closeMenu();
      lastScrollY = window.scrollY;
    }, { passive: true });

    // Also close when a link is tapped
    links.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  }
}

// ===== SCROLL REVEAL =====
function initReveal() {
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal, .lb-row, .coll-card, .statement-quote, .statement-attr').forEach(el => obs.observe(el));
}

// ===== CART =====
let cart = JSON.parse(localStorage.getItem('missles_v2') || '[]');

function saveCart() {
  localStorage.setItem('missles_v2', JSON.stringify(cart));
  updateBadge();
  renderDrawer();
}

function updateBadge() {
  const n = cart.reduce((s, i) => s + i.qty, 0);
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = n;
    el.style.display = n > 0 ? 'flex' : 'none';
  });
}

function addToCart(name, price, variant = 'One Size') {
  const ex = cart.find(i => i.name === name && i.variant === variant);
  if (ex) ex.qty++;
  else cart.push({ id: Date.now(), name, price, variant, qty: 1 });
  saveCart();
  showToast('Added to your cart');
  openCart();
}

function removeItem(id) { cart = cart.filter(i => i.id !== id); saveCart(); }

function changeQty(id, d) {
  const item = cart.find(i => i.id === id);
  if (!item) return;
  item.qty = Math.max(0, item.qty + d);
  if (item.qty === 0) removeItem(id); else saveCart();
}

function cartTotal() { return cart.reduce((s, i) => s + i.price * i.qty, 0); }

function renderDrawer() {
  const body = document.querySelector('.cart-body');
  const foot = document.querySelector('.cart-foot');
  if (!body) return;

  if (!cart.length) {
    body.innerHTML = '<div class="cart-empty-msg"><div class="cart-empty-icon">∅</div><div class="cart-empty-text">Your cart is empty</div></div>';
    if (foot) foot.style.display = 'none';
    return;
  }
  if (foot) foot.style.display = 'block';

  body.innerHTML = cart.map(i => `
    <div class="cart-item">
      <div class="cart-item-img"></div>
      <div>
        <div class="cart-item-name">${i.name}</div>
        <div class="cart-item-var">${i.variant}</div>
        <div class="cart-qty">
          <button class="qty-btn" onclick="changeQty(${i.id},-1)">−</button>
          <span class="qty-num">${i.qty}</span>
          <button class="qty-btn" onclick="changeQty(${i.id},1)">+</button>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px">
        <div class="cart-item-price">$${(i.price * i.qty).toFixed(2)}</div>
        <button class="cart-item-rm" onclick="removeItem(${i.id})">×</button>
      </div>
    </div>`).join('');

  const sv = document.querySelector('.cart-sub-val');
  if (sv) sv.textContent = '$' + cartTotal().toFixed(2);
}

function openCart() {
  document.querySelector('.cart-drawer')?.classList.add('open');
  document.querySelector('.cart-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.querySelector('.cart-drawer')?.classList.remove('open');
  document.querySelector('.cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

// ===== TOAST =====
function showToast(msg) {
  let t = document.querySelector('.toast');
  if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._tid);
  t._tid = setTimeout(() => t.classList.remove('show'), 3200);
}

// ===== FILTERS =====
function initFilters() {
  document.querySelectorAll('.filter-pill').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-pill').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const f = btn.dataset.filter;
      document.querySelectorAll('.coll-card').forEach(c => {
        const show = f === 'all' || c.dataset.type === f;
        c.style.display = show ? '' : 'none';
        if (show) setTimeout(() => c.classList.add('visible'), 60);
        else c.classList.remove('visible');
      });
    });
  });
}

// ===== IMAGE UPLOAD — LOOKBOOK =====
function initLookbookUpload() {
  document.querySelectorAll('.lb-photo').forEach(photo => {
    if (photo._init) return;
    photo._init = true;
    photo.addEventListener('click', () => {
      const inp = document.createElement('input');
      inp.type = 'file'; inp.accept = 'image/*';
      inp.onchange = e => {
        const file = e.target.files[0]; if (!file) return;
        const reader = new FileReader();
        reader.onload = ev => {
          photo.innerHTML = `
            <img src="${ev.target.result}" alt="">
            <div class="lb-caption"><h4>Missles Editorial</h4><p>SS25 Collection</p></div>
            <div class="upload-hint-overlay">
              <svg viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/></svg>
              <span>Replace</span>
            </div>`;
          photo._init = false;
          initLookbookUpload();
        };
        reader.readAsDataURL(file);
      };
      inp.click();
    });
  });
}

// ===== IMAGE UPLOAD — COLLECTION =====
function initCollectionUpload() {
  document.querySelectorAll('.coll-img-placeholder').forEach(ph => {
    if (ph._init) return;
    ph._init = true;
    ph.addEventListener('click', e => {
      e.stopPropagation();
      const inp = document.createElement('input');
      inp.type = 'file'; inp.accept = 'image/*';
      inp.onchange = ev => {
        const file = ev.target.files[0]; if (!file) return;
        const reader = new FileReader();
        reader.onload = re => {
          const wrap = ph.closest('.coll-img-wrap');
          if (!wrap) return;
          const btn = wrap.querySelector('.coll-add');
          const onc = btn ? btn.getAttribute('onclick') : '';
          wrap.innerHTML = `<img class="coll-img" src="${re.target.result}" alt="">
            <button class="coll-add" onclick="${onc}">Add to Cart</button>`;
        };
        reader.readAsDataURL(file);
      };
      inp.click();
    });
  });
}

// ===== HERO IMAGE UPLOAD =====
function initHeroUpload() {
  const zone = document.querySelector('.hero-upload-zone');
  if (!zone) return;
  zone.addEventListener('click', () => {
    const inp = document.createElement('input');
    inp.type = 'file'; inp.accept = 'image/*';
    inp.onchange = e => {
      const file = e.target.files[0]; if (!file) return;
      const reader = new FileReader();
      reader.onload = ev => {
        const media = document.querySelector('.hero-media');
        if (media) media.innerHTML = `<img class="hero-uploaded-img" src="${ev.target.result}" alt="Hero">`;
        zone.style.display = 'none';
      };
      reader.readAsDataURL(file);
    };
    inp.click();
  });
}

// ===== EDITORIAL UPLOAD =====
function initEditorialUpload() {
  document.querySelectorAll('.editorial-img-placeholder').forEach(ph => {
    if (ph._init) return;
    ph._init = true;
    ph.addEventListener('click', () => {
      const inp = document.createElement('input');
      inp.type = 'file'; inp.accept = 'image/*';
      inp.onchange = e => {
        const file = e.target.files[0]; if (!file) return;
        const reader = new FileReader();
        reader.onload = ev => {
          const wrap = ph.closest('.editorial-img-wrap');
          if (wrap) wrap.innerHTML = `<img class="editorial-img" src="${ev.target.result}" alt="">`;
        };
        reader.readAsDataURL(file);
      };
      inp.click();
    });
  });
}

// ===== PAGE NAVIGATION =====
function showPage(id) {
  document.querySelectorAll('.page-section').forEach(p => p.classList.remove('active'));
  const pg = document.getElementById('page-' + id);
  if (pg) {
    pg.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  closeCart();
  if (id === 'lookbook') setTimeout(initLookbookUpload, 100);
  if (id === 'collection') setTimeout(() => { initCollectionUpload(); initReveal(); initFilters(); }, 100);
  if (id === 'cart') renderCartPage();
  if (id === 'checkout') renderCheckout();
}

// ===== CART PAGE =====
function renderCartPage() {
  const con = document.getElementById('cart-page-items');
  const foot = document.getElementById('cart-page-foot');
  if (!con) return;

  if (!cart.length) {
    con.innerHTML = '<div class="cart-page-empty">Your cart is empty</div>';
    if (foot) foot.style.display = 'none';
    return;
  }
  if (foot) foot.style.display = 'block';

  con.innerHTML = cart.map(i => `
    <div style="display:grid;grid-template-columns:90px 1fr auto;gap:20px;padding:24px 0;border-bottom:1px solid rgba(255,255,255,0.06);align-items:start;">
      <div style="aspect-ratio:3/4;background:var(--grey-dark);"></div>
      <div>
        <div style="font-family:var(--font-serif);font-size:17px;font-weight:400;color:var(--white);margin-bottom:4px;">${i.name}</div>
        <div style="font-family:var(--font-sans);font-size:10px;font-weight:300;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,0.3);margin-bottom:14px;">${i.variant}</div>
        <div style="display:flex;align-items:center;gap:14px;">
          <button onclick="cpQty(${i.id},-1)" style="width:26px;height:26px;border:1px solid rgba(255,255,255,0.15);background:none;color:var(--white);font-size:15px;cursor:pointer;display:flex;align-items:center;justify-content:center;">−</button>
          <span style="font-family:var(--font-sans);font-size:13px;color:var(--white);">${i.qty}</span>
          <button onclick="cpQty(${i.id},1)" style="width:26px;height:26px;border:1px solid rgba(255,255,255,0.15);background:none;color:var(--white);font-size:15px;cursor:pointer;display:flex;align-items:center;justify-content:center;">+</button>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px;">
        <div style="font-family:var(--font-sans);font-size:13px;color:rgba(255,255,255,.65);">$${(i.price*i.qty).toFixed(2)}</div>
        <button onclick="cpRm(${i.id})" style="font-family:var(--font-sans);font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,0.25);background:none;border:none;cursor:pointer;transition:color .2s;" onmouseover="this.style.color='#fff'" onmouseout="this.style.color='rgba(255,255,255,0.25)'">Remove</button>
      </div>
    </div>`).join('');

  const tot = cart.reduce((s,i)=>s+i.price*i.qty, 0);
  const te = document.getElementById('cart-page-total');
  if (te) te.textContent = '$' + tot.toFixed(2);
}

window.cpQty = function(id, d) {
  const item = cart.find(i => i.id === id);
  if (item) { item.qty = Math.max(0, item.qty + d); if (item.qty === 0) cart = cart.filter(i=>i.id!==id); }
  saveCart(); renderCartPage();
};
window.cpRm = function(id) { cart = cart.filter(i=>i.id!==id); saveCart(); renderCartPage(); };

// ===== CHECKOUT =====
function renderCheckout() {
  const con = document.getElementById('checkout-items');
  if (!con) return;

  con.innerHTML = cart.map(i => `
    <div class="summary-item">
      <div class="summary-item-img"></div>
      <div class="summary-item-info">
        <div class="summary-item-name">${i.name}</div>
        <div class="summary-item-var">${i.variant} × ${i.qty}</div>
      </div>
      <div class="summary-item-price">$${(i.price*i.qty).toFixed(2)}</div>
    </div>`).join('');

  const sub = cartTotal();
  const tax = sub * 0.08;
  const ship = sub > 150 ? 0 : 12;
  const total = sub + tax + ship;

  const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
  set('co-sub', '$' + sub.toFixed(2));
  set('co-ship', ship === 0 ? 'Complimentary' : '$' + ship.toFixed(2));
  set('co-tax', '$' + tax.toFixed(2));
  set('co-total', '$' + total.toFixed(2));
}

function placeOrder() {
  const form = document.getElementById('coForm');
  const inputs = form?.querySelectorAll('input[required]') || [];
  let ok = true;
  inputs.forEach(i => {
    if (!i.value.trim()) {
      ok = false;
      i.style.borderBottomColor = 'rgba(255,100,100,0.5)';
      setTimeout(() => i.style.borderBottomColor = '', 2000);
    }
  });
  if (!ok) return;
  cart = []; saveCart();
  const btn = document.querySelector('.place-order-btn');
  if (btn) btn.textContent = '✓ Order Confirmed';
  setTimeout(() => {
    const layout = document.querySelector('.checkout-grid');
    if (layout) layout.innerHTML = `
      <div style="grid-column:1/-1;text-align:center;padding:80px 0;">
        <div style="font-family:var(--font-serif);font-style:italic;font-size:72px;font-weight:300;color:var(--white);margin-bottom:20px;">Thank you.</div>
        <p style="font-family:var(--font-sans);font-size:10px;letter-spacing:0.28em;text-transform:uppercase;color:rgba(255,255,255,0.35);margin-bottom:48px;">Your order is confirmed. A receipt has been sent.</p>
        <a href="#" onclick="showPage('home')" class="btn-ghost">Return Home</a>
      </div>`;
  }, 1000);
}

// ===== CARD FORMAT =====
function initCardFormat() {
  const el = document.getElementById('cardNum');
  if (!el) return;
  el.addEventListener('input', e => {
    let v = e.target.value.replace(/\D/g,'').substring(0,16);
    e.target.value = v.replace(/(.{4})/g,'$1 ').trim();
  });
}

// ===== INIT =====
document.addEventListener('DOMContentLoaded', () => {
  initStars();
  initCursor();
  initNav();
  initReveal();
  initHeroUpload();
  initEditorialUpload();
  updateBadge();
  renderDrawer();
  initCardFormat();

  // Cart events
  document.querySelectorAll('[data-open-cart]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  document.querySelector('.cart-overlay')?.addEventListener('click', closeCart);
  document.querySelector('.cart-head-close')?.addEventListener('click', closeCart);
  document.querySelector('.cart-checkout-btn')?.addEventListener('click', e => { e.preventDefault(); closeCart(); showPage('checkout'); });
  document.querySelector('.cart-view-btn')?.addEventListener('click', e => { e.preventDefault(); closeCart(); showPage('cart'); });
});

// ===== COLLECTION FILTERS (runs on Shopify collection pages) =====
function initCollectionFilters() {
  document.querySelectorAll('.filter-pill').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.filter-pill').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      var f = this.dataset.filter;
      document.querySelectorAll('.coll-card').forEach(function(card) {
        var show = f === 'all' || card.dataset.type === f;
        card.style.display = show ? '' : 'none';
        if (show) setTimeout(function() { card.classList.add('visible'); }, 50);
        else card.classList.remove('visible');
      });
    });
  });
  // Animate cards on load
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.05 });
  document.querySelectorAll('.coll-card').forEach(function(el) { obs.observe(el); });
}

// ===== SHOPIFY CART ADD (live products) =====
function addToCartShopify(variantId, name, price) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() { addToCart(name, price); })
  .catch(function()  { addToCart(name, price); });
}

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.collection-grid')) initCollectionFilters();
});

// ===== FREE SHIPPING PROGRESS BAR =====
function updateShipProgress() {
  var fill = document.getElementById('cartShipFill');
  var msg  = document.getElementById('cartShipMsg');
  if (!fill || !msg) return;

  var cart      = JSON.parse(localStorage.getItem('missles_v2') || '[]');
  var total     = cart.reduce(function(s, i) { return s + (i.price * i.qty); }, 0);
  var threshold = 150;
  var remaining = Math.max(0, threshold - total);
  var pct       = Math.min(100, (total / threshold) * 100);

  fill.style.width = pct + '%';

  if (remaining <= 0) {
    msg.innerHTML = '<strong>You\'ve unlocked free shipping!</strong> 🎉';
  } else {
    msg.innerHTML = 'You\'re <strong>$' + remaining.toFixed(2) + '</strong> away from free shipping';
  }
}

// Patch addToCart to also update progress bar
var _origAddToCart = window.addToCart;
if (typeof _origAddToCart === 'function') {
  window.addToCart = function() {
    _origAddToCart.apply(this, arguments);
    updateShipProgress();
  };
}

document.addEventListener('DOMContentLoaded', function() {
  updateShipProgress();
  // Re-run whenever cart drawer opens
  document.addEventListener('click', function(e) {
    if (e.target && e.target.closest('[data-open-cart]')) {
      setTimeout(updateShipProgress, 50);
    }
  });
});
